import axiosTokenInstance from 'services/api/backoffice';
import { DETAIL_TRANSACTIONS_STRIPE, DETAIL_TRANSACTIONS_STRIPE_ERROR } from '_models/redux/types';

// Action function
export const detailStripeAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/reports/stripe-transactions/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_TRANSACTIONS_STRIPE,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_TRANSACTIONS_STRIPE_ERROR,
      response: e || {},
    });
  }
};
